/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAccountInactivity } from '../../axios/whatsAppAccountInactivity'
import type {
	WhatsAppAccountInactivityError,
	WhatsAppAccountInactivityPathParams,
	WhatsAppAccountInactivityResponse,
} from '../../types/WhatsAppAccountInactivity'

export const whatsAppAccountInactivityQueryKey = (
	organisationId: WhatsAppAccountInactivityPathParams['organisationId'],
) => [{ url: '/organisations/:organisationId/whatsapp-account/inactivity', params: { organisationId } }] as const

export type WhatsAppAccountInactivityQueryKey = ReturnType<typeof whatsAppAccountInactivityQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::inactivity */
export function whatsAppAccountInactivityQueryOptions(
	organisationId: WhatsAppAccountInactivityPathParams['organisationId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppAccountInactivityResponse,
		AxiosError<WhatsAppAccountInactivityError>,
		WhatsAppAccountInactivityResponse,
		WhatsAppAccountInactivityQueryKey
	>({
		queryKey: whatsAppAccountInactivityQueryKey(organisationId),
		queryFn: ({ signal }) => whatsAppAccountInactivity(organisationId, { signal, ...config }).then(res => res.data),
		enabled: !!organisationId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::inactivity */
export function useWhatsAppAccountInactivity<TSelectData = WhatsAppAccountInactivityResponse>(
	organisationId: WhatsAppAccountInactivityPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppAccountInactivityResponse,
					AxiosError<WhatsAppAccountInactivityError>,
					TSelectData,
					WhatsAppAccountInactivityQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppAccountInactivityError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppAccountInactivityQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::inactivity */
export function useWhatsAppAccountInactivitySuspense<TSelectData = WhatsAppAccountInactivityResponse>(
	organisationId: WhatsAppAccountInactivityPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppAccountInactivityResponse,
					AxiosError<WhatsAppAccountInactivityError>,
					TSelectData,
					WhatsAppAccountInactivityQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppAccountInactivityError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppAccountInactivityQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
